import Repository from '../../repositories/RepositoryFactory';
const ccmTimeLogsRepository = Repository.get('ccmTimeLogs');

export default {
  namespaced: true,
  state: {
    ccmTimeLogsByPatientId: [],
    ccmTimeLogsByCCMRecordId: [],
    ccmTimeLog: null,
  },
  mutations: {
    STORE_CCM_TIME_LOGS_BY_PATIENT_ID (state, payload) {
      state.ccmTimeLogsByPatientId = payload;
    },
    STORE_CCM_TIME_LOGS_BY_CCM_ID (state, payload) {
      state.ccmTimeLogsByCCMRecordId = payload;
    },
    STORE_CCM_TIME_LOG (state, payload) {
      state.ccmTimeLog = payload;
    },
    UPDATE_CCM_TIME_LOG (state, payload) {
      state.ccmTimeLog = {
        ...state.ccmTimeLog,
        ...payload,
      };
    },
  },
  actions: {
    async getCCMTimeLogsByPatientId ({ commit }, patientId) {
      const response = await ccmTimeLogsRepository.getCCMTimeLogsByPatientId(
        patientId,
      );
      commit('STORE_CCM_TIME_LOGS_BY_PATIENT_ID', response.data);
    },
    async getCCMTimeLogsByCCMId ({ commit }, CCMId) {
      const response = await ccmTimeLogsRepository.getCCMTimeLogsByCCMId(CCMId);
      commit('STORE_CCM_TIME_LOGS_BY_CCM_ID', response.data);
    },
    async getCCMTimeLog ({ commit }, id) {
      const response = await ccmTimeLogsRepository.getCCMTimeLog(id);
      commit('STORE_CCM_TIME_LOG', response.data);
    },
    async updateCCMTimeLog ({ commit }, request) {
      return await ccmTimeLogsRepository.updateCCMTimeLog(
        request.id,
        request.body,
      );
    },
    async updateCCMTimeLogByCCMId ({ commit }, request) {
      return await ccmTimeLogsRepository.updateCCMTimeLog(
        request.ccmId,
        request.body,
      );
    },
    async deleteCCMTimeLog ({ commit }, id) {
      return await ccmTimeLogsRepository.deleteCCMTimeLog(id);
    },
    async addCCMTimeLog ({ commit }, body) {
      return await ccmTimeLogsRepository.addCCMTimeLog(body);
    },
    async getTimeLogEntryCountsByPatientid ({ commit }, body) {
      return await ccmTimeLogsRepository.getTimeLogEntryCountsByPatientid(body);
    },
    async getTimeLogEntryCountsByPatientidByDate ({ commit }, body) {
      return await ccmTimeLogsRepository.getTimeLogEntryCountsByPatientidByDate(body);
    },
  },
};
